import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { I18nModule } from 'app/core/services/i18n/i18n.module';
import { ValidationModule } from 'app/core/services/validation/validation.module';
import { DynamicSachverhalteFormModule } from 'app/modules/dossier-area/components/dynamic-sachverhalte-form/dynamic-sachverhalte-form.module';
import { SachverhaltCreateComponent } from 'app/modules/shared-area/entry-components/sachverhalt/sachverhalt-create/sachverhalt-create.component';
import { FocusNearestModule } from 'app/shared/directives/focusNearest/focusNearest.module';
import { IsLoadingModule } from 'app/shared/directives/is-loading-directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StoreModule,
    ValidationModule,
    I18nModule,
    TranslateModule,
    DynamicSachverhalteFormModule,
    IsLoadingModule,
    FocusNearestModule
  ],
  declarations: [SachverhaltCreateComponent],
  exports: [SachverhaltCreateComponent],
})
export class SachverhaltCreateModule {}
